module.exports = __webpack_public_path__ + "img/invest_list3.6b5b5b5b.png";